var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var ItemPriceService = /** @class */ (function (_super) {
    __extends(ItemPriceService, _super);
    function ItemPriceService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this._subject = new Subject();
        return _this;
    }
    Object.defineProperty(ItemPriceService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ItemPriceService.prototype.checkItem = function (cols, rec) {
        var items = rec[cols[0].key] || [];
        var its = [];
        var check = true;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if ((!(cols[0].required && i === 0) && !this.colservice.checkVal(item.start_date)) || !this.colservice.checkVal(item.price)) {
                check = false;
            }
            its.push(item);
        }
        if (cols[0].required && its.length === 0) {
            check = false;
            this._subject.next(true);
        }
        return check;
    };
    ItemPriceService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ItemPriceService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return ItemPriceService;
}(ContentBaseService));
export { ItemPriceService };
var Item = /** @class */ (function () {
    function Item() {
        this.$type = "post" /* Post */;
    }
    return Item;
}());
export { Item };
var Editable = /** @class */ (function () {
    function Editable() {
        this.delete = true;
        this.start_date = true;
        this.price = true;
    }
    return Editable;
}());
export { Editable };
//# sourceMappingURL=item-price.service.js.map